<ng-container *transloco="let t">
  <div class="owner-statement-ownership-change">
    <div [formGroup]="form">
      <h3 class="mb-2">
        {{ t('Owner Statement Regarding Change of Ownership') }}
      </h3>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t("New owner's full name") }}</mat-label>
        <input matInput formControlName="newOwnerName" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t("New owner's address") }}</mat-label>
        <input matInput formControlName="newOwnerAddress" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Contact phone') }}</mat-label>
        <input matInput formControlName="newOwnerPhone" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Note') }}</mat-label>
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
